<template>
  <div class="parent-box">
    <div class="">
      <div>
        <div class="">
          <div>
            <br />
            <div class="text-left pb-2">Tenure (Months)</div>

            <div>
              <p style="width: 100%;">
                <vue-number-input
                  v-model="ten"
                  :step="6"
                  :min="6"
                  :max="36"
                  size="large"
                  :inputtable="false"
                  center
                  controls
                  @click="PMT(0.015, ten, typeProduct - value, 0, 0)"
                ></vue-number-input>
              </p>
            </div>
            <br />

            <!-- <div class="pt-3">
              <el-checkbox v-model="depositCondition" @change="resetUpfront()"
                >Do you to want make an upfront deposit ?</el-checkbox
              >
            </div> 
            <br />

            <div v-show="depositCondition">
              <div class="text-left pb-2">Upfront Deposit</div>
              <div>
                <div>
                  <p style="width: 100%;">
                    <vue-number-input
                      v-model="value"
                      :step="100000"
                      :min="0"
                      :max="
                        typeProduct % 100000 === 0
                          ? typeProduct - 100000
                          : Math.floor(typeProduct * 0.00001) * 100000
                      "
                      size="large"
                      @keydown="PMT(0.015, ten, typeProduct - value, 0, 0)"
                      :inputtable="false"
                      center
                      controls
                    ></vue-number-input>
                  </p>
                </div>
              </div>
              <br />
            </div> -->

            <hr />
            <div v-show="form.product">
              <div class="results">
                <div class="d-flex justify-content-between align-items-center">
                  <div class="bold-text">Total Payment</div>
                  <div v-if="ten == 0 && value == 0" class="bold-text">
                    NGN {{
                      Intl.NumberFormat("en-US").format(typeProduct)
                    }}
                  </div>
                  <div v-if="ten != 0" class="bold-text">
                    NGN {{
                      Intl.NumberFormat("en-US").format(
                            ten * monthlyPaymentValue + (0.05 * typeProduct) + value
                          )
                    }}
                  </div>
                </div>
                <hr />
                <div class="d-flex justify-content-between align-items-center">
                  <div>Total 1st Month Payment 
                    <br/>
                    <i>(Payable now)</i>
                  </div>
                  <div v-if="ten == 0 && value == 0">
                    NGN {{ Intl.NumberFormat("en-US").format(typeProduct + (0.05 * typeProduct)) }}
                  </div>
                  <div v-if="ten != 0">
                    NGN {{
                      Intl.NumberFormat("en-US").format(
                            2 * monthlyPaymentValue + (0.05 * typeProduct) + value
                          )
                    }}
                  </div>
                </div>
                <br/>

                <ul>
                  <li>
                    <div class="d-flex justify-content-between align-items-center">
                      <div >Monthly Payment</div>
                      <div>
                        <div>
                          NGN {{
                            monthlyPaymentValue == "Infinity"
                              ? "0.00"
                              : Intl.NumberFormat("en-US").format(
                                  monthlyPaymentValue
                                )
                          }}
                        </div>
                      </div>
                    </div>

                  </li>                  
                  <br />

                  <li>
                    <div class="d-flex justify-content-between align-items-center">
                      <div>Caution Fee (Refundable)</div>
                      <div>
                        NGN {{
                          monthlyPaymentValue == "Infinity"
                            ? "0.00"
                            : Intl.NumberFormat("en-US").format(monthlyPaymentValue)
                        }}
                      </div>
                    </div>
                  </li>                  
                  <br />

                  <li>
                    <div class="d-flex justify-content-between align-items-center">
                      <div>Upfront Deposit</div>
                      <div>
                        NGN {{ Intl.NumberFormat("en-US").format(0.05 *  typeProduct) }}
                      </div>
                    </div>
                  </li>
                </ul>               

                <hr />
                <div class="d-flex justify-content-between align-items-center">
                  <div>Subsequent Payments</div>
                  <div>
                    NGN {{
                      monthlyPaymentValue == "Infinity"
                        ? "0.00"
                        : Intl.NumberFormat("en-US").format(monthlyPaymentValue)
                    }}
                  </div>
                </div>
                <br />
              </div>
            </div>
          </div>
        </div>
        <div></div>
      </div>

      <div>
        <div>
          <!-- <div v-if="modalstate" className="text-center">
            <div class="submit-gif">
              <div
                class="spinner-border"
                style="width: 3rem; height: 3rem;"
                role="status"
              >
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          </div> -->
          <!-- v-else -->
          <div>
            <button @click="passReqFunc" class="submit-button" type="button">
              Next &rarr;
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ArnergyInput from "../ArnergyInput";
import ArnergySelect from "../ArnergySelect.vue";
import Vue from "vue";
import { mapGetters, mapActions } from "vuex";
import Agreement from "./Agreement";
import VueIntlNumberformat from "vue-intl-numberformat";
import VueNumberInput from "@chenfengyuan/vue-number-input";
import * as calConfig from "./configCal.js";

import {
  Select,
  Button,
  Autocomplete,
  Form,
  FormItem,
  Radio,
  RadioGroup,
  Checkbox,
  RadioButton
  // ...
} from "element-ui";

export default {
  name: "Modal",
  props: {
    typeProduct: 10,
    productName: "product"
  },
  components: {
    ArnergyInput,
    ArnergySelect,
    VueIntlNumberformat,
    VueNumberInput,
    "el-checkbox": Checkbox,
    Agreement
  },
  computed: {},
  data() {
    return {
      range: [0, 500],
      numberPay: 500,
      monthlyPaymentValue: "",
      ten: 6,
      value: 0,
      costShow: false,
      answer: "",
      showAgreement: false,
      depositCondition: false,
      finalFP: "",
      recurringPaymentSetups: "",
      activeIndex: 0,
      numberTenure: "",
      deposits: [
        { id: "2900000", name: "Arnergy 5000" },
        { id: "4500000", name: "Arnergy 5000X" },
        { id: "7500000", name: "Arnergy 10000" }
      ],

      tenures: [
        { id: "12 Months tenure ", name: "12 Months tenure" },
        { id: "24 Months tenure", name: "24 Months tenure" },
        { id: "36 Months tenure", name: "36 Months tenure" }
      ],
      form: {
        product: "2900000",
        income: "",
        employment: ""
      },
      formErrors: {},
      // activeIndex: 0,
      summary: {}
      // firstPaymentAmt
      // recurrentMonthlyAmt
      // totalPayment
      // cautionFee
      // setupFee
      // upfrontPayment
    };
  },

  methods: {
    ...mapActions(["setUserAmounty", "setTest"]),

    gotoNextState() {
      // this.$emit("updateStatus");
    },
    resetUpfront() {
      if (!this.depositCondition) {
        this.value = 0;
        this.PMT(0.015, this.ten, this.typeProduct - this.value, 0, 0);
      }
      // console.log("Resetting...", this.depositCondition);
    },
    PMT(rate = 0.015, nperiod, pv, fv = 0, type = 0) {
      if (rate == 0) return -(pv + fv) / nperiod;

      var pvif = Math.pow(1 + rate, nperiod);
      var pmt = (rate / (pvif - 1)) * -((pv - (0.05 * pv)) * pvif + fv);

      if (type == 1) {
        pmt /= 1 + rate;
      }
      this.monthlyPaymentValue =
        Math.abs(pmt) === "Infinity" ? 0.0 : Math.abs(pmt).toFixed(2);
    },

    passReqFunc() {
      const data = {
        monthlyPayment: this.monthlyPaymentValue,
        tenure: this.ten + "",
        upfrontPayment: this.value + "",
        cautionFee: this.monthlyPaymentValue,
        setupFee: this.productName == "Arnergy 5000X" ? "60000" : "0",
        totalFirstPayment:
          this.ten == 0 && this.value == 0
            ? Number(this.monthlyPaymentValue) * 2 + (0.05 * this.typeProduct) + ""
            : Number(this.monthlyPaymentValue) * 2 + this.value + (0.05 * this.typeProduct) + "",
        totalPayment:
          this.ten == 0 && this.value == 0
            ? this.typeProduct + (0.05 * this.typeProduct) + ""
            : (
                this.ten * this.monthlyPaymentValue +
                (0.05 * this.typeProduct) +
                this.value
              ).toFixed(2) + ""
      };

      localStorage.amtPay = data.totalFirstPayment;
      localStorage.amtRepay = data.monthlyPayment;
      localStorage.proTenure = data.tenure;
      localStorage.cautionFee = data.cautionFee;
      localStorage.setupFee = data.setupFee;
      localStorage.upfrontPayment = data.upfrontPayment;
      localStorage.totalPayment = data.totalPayment;
      this.$store.commit("setUserAmount", data.totalFirstPayment);

      // console.log(data);
      if (data.monthlyPayment == 0) {
        this.$emit("toKyc");
      } else {
        this.$emit("nextFunc");
      }

      // this.$emit('nextFunc',data);
    }
  },
  async mounted() {
    this.PMT(0.015, this.ten.length > 6 ? this.ten : 6, this.typeProduct, 0, 0);

    // this.setComponentParams();
    // console.log("type product", this.typeProduct);
    // console.log("product name", this.productName);
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/scss/_reduced_variables.scss";

.modal-mask {
  margin-top: 30px;
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

#style1 {
  background: red !important;
}

.amt {
  font-size: 25px;
  color: $secondary-color;
  font-weight: bold;
}

.info-footer {
  float: left;
  margin-bottom: 3rem;
}

.modal-container {
  width: 500px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  height: 90vh;
  overflow-y: scroll;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header {
  margin-top: 0;
  color: #42b983;
  position: relative;
  .close-btn {
    color: orangered;
    font-size: 16px;
    position: absolute;
    cursor: pointer;
    top: 0;
    right: 0;
  }
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.submit-button {
  display: block;
  color: white;
  width: 100%;
  text-align: center;
  padding: 15px 32px;
  margin-top: 20px;
  border: 0;
  background-color: $secondary-color;
  font-weight: bold;

  &:hover {
    background-color: darken($secondary-color, 10%);
  }
}
.heading {
  text-align: center;
  margin: auto;
  max-width: 550px;
}

.link {
  color: $primary-color;
  font-weight: bold;
}

.login-title {
  margin-bottom: 40px;
  font-weight: 900;
  font-size: 32px;
  color: $primary-color;
}

.submit-gif {
  display: block;
  color: white;
  width: 100%;
  text-align: center;
  color: white;
  padding: 15px 32px;
  margin-top: 20px;
  border: 0;
  background-color: $secondary-color;
}
.bold-text {
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/kitchen/Onboarding/Calculator.vue